// extracted by mini-css-extract-plugin
export default {"wrapper":"EmailLogs_wrapper__odrZp","tableContainer":"EmailLogs_tableContainer__KrE0i","filters":"EmailLogs_filters__AoNXT","noResults":"EmailLogs_noResults__wUw+F"};